import React, { useMemo } from 'react'
import styled from 'styled-components'
import { colours } from '@qflow/theme'

export function WasteManagementRoutes({ data }) {
  const dataObject = useMemo(() => {
    const dataObject = {}
    data.forEach(item => {
      dataObject[item.summary] = item
    })
    return dataObject
  }, [data])

  const orderedSummaryManagementRouteTypes = [
    'Exemption',
    'Reuse',
    'Recycling',
    'Recovery',
    'Disposal',
    'Transfer',
    'Unknown'
  ]

  const formatValue = value => {
    let formattedValue = value
    if (value === undefined || value === null) {
      return 'missing weight'
    }
    if (typeof value === 'number') {
      formattedValue = value.toFixed(3)
    }
    if (typeof value === 'string') {
      const parsedValue = parseFloat(value)
      if (!isNaN(parsedValue)) {
        formattedValue = parsedValue.toFixed(3)
      }
    }
    if (formattedValue === '0.000') {
      formattedValue = '< 0.001'
    }

    return `${formattedValue} tonnes`
  }

  return (
    <SummaryManagementRouteTypeWrapper>
      {orderedSummaryManagementRouteTypes.map(summaryManagementRouteType => {
        return dataObject[summaryManagementRouteType] ? (
          <SummaryManagementRouteType key={summaryManagementRouteType}>
            <Row>
              <h5>{summaryManagementRouteType} (total)</h5>
              <SummaryManagementRouteTypeTotal>
                {formatValue(
                  dataObject[summaryManagementRouteType].summaryWeight
                )}
              </SummaryManagementRouteTypeTotal>
            </Row>
            {dataObject[summaryManagementRouteType].details.map(
              (detail, index) => {
                return (
                  <Row key={`${summaryManagementRouteType}-${index}`}>
                    <div>{detail.detail}</div>
                    <div>{formatValue(detail.detailWeight)}</div>
                  </Row>
                )
              }
            )}
          </SummaryManagementRouteType>
        ) : null
      })}
    </SummaryManagementRouteTypeWrapper>
  )
}

const SummaryManagementRouteTypeWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  padding: 0.5rem 0.5rem 0.5rem 0.75rem;
  gap: 0.75rem;
`
const SummaryManagementRouteType = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-basis: 33.33%;
  padding: 0.625rem;
  border: 1px solid ${colours.BORDER_GREY};
  background-color: ${colours.WHITE};
  border-radius: 0.5rem;
  min-width: 250px;
  max-width: calc(33.3333% - 0.625rem);

  h5 {
    color: ${colours.CORE_NAVY};
    font-size: 0.75rem;
    font-weight: 700;
    margin-bottom: 0.125rem;
  }
`
const Row = styled.div`
  display: flex;
  justify-content: space-between;

  > div {
    font-size: 0.75rem;
  }
`
const SummaryManagementRouteTypeTotal = styled.div`
  font-size: 0.75rem;
  font-weight: 700;
  margin-bottom: 0.125rem;
`
